'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = require('react');
var ReactDOM = require('react-dom');
var _ = require('lodash');
var compose = require('../hoc/compose');
var tooltipPositionUtil = require('../util/tooltipPosition');
var Bubble = require('./bubble');
var template = require('./tooltip.rt');
var displayNames = require('./displayNames');
var ReactCSSTransitionGroup = require('react-addons-css-transition-group');

var _require = require('../util/rect'),
    getRectByReactElement = _require.getRectByReactElement;

var rectToStyle = function rectToStyle(rect) {
    return {
        top: rect.y,
        left: rect.x,
        height: rect.height,
        width: rect.width
    };
};

var ANIMATION_DURATION = 200;
var withTransition = function withTransition(props) {
    return React.createElement(ReactCSSTransitionGroup, {
        transitionName: 'tooltip',
        // transitionAppear: true,
        // transitionAppearTimeout: ANIMATION_DURATION,
        transitionEnter: false,
        transitionLeaveTimeout: props.animationDuration || ANIMATION_DURATION
    }, props.children);
};

var shouldBeOpen = function shouldBeOpen(props, state) {
    return !props.disabled && (props.isOpen || state.isOpen);
};

var Tooltip = function (_React$Component) {
    _inherits(Tooltip, _React$Component);

    function Tooltip(props) {
        _classCallCheck(this, Tooltip);

        var _this = _possibleConstructorReturn(this, (Tooltip.__proto__ || Object.getPrototypeOf(Tooltip)).call(this, props));

        _this.state = {
            isOpen: false,
            contentStyle: {},
            chupchikStyle: {},
            chupchikAlignment: ''
        };
        _this.timer = null;

        _this.open = function () {
            return _this.setState({ isOpen: true });
        };
        _this.close = function () {
            return _this.setState({ isOpen: false });
        };

        _this.isOpen = function () {
            return shouldBeOpen(_this.props, _this.state);
        };

        var mountPoint = null;
        _this.getMountPoint = function () {
            if (!mountPoint) {
                mountPoint = window.document.createElement('div');
                window.document.body.appendChild(mountPoint);
            }
            return mountPoint;
        };

        _this.removeMountPoint = function () {
            if (mountPoint) {
                ReactDOM.unmountComponentAtNode(mountPoint);
                window.document.body.removeChild(mountPoint);
                _this.tooltipPortal = null;
                mountPoint = null;
            }
        };

        _this.onLayoutChange = function (contentRef) {
            var viewport = tooltipPositionUtil.getViewportSize();
            var contentRect = getRectByReactElement(contentRef);
            var trigger = getRectByReactElement(_this.props.customTrigger || _this);

            var CONSTS = tooltipPositionUtil.CONSTS;

            var params = {
                alignment: _this.props.alignment || CONSTS.ALIGNMENT.TOP
            };

            // TODO: Refactor + naming
            var initialPosition = tooltipPositionUtil.getContentPosition(viewport, trigger, contentRect, params);

            var _tooltipPositionUtil$ = tooltipPositionUtil.getFinalPositions(viewport, trigger, initialPosition, params),
                content = _tooltipPositionUtil$.content,
                chupchik = _tooltipPositionUtil$.chupchik;

            var chupchikAlignment = void 0;
            if (tooltipPositionUtil.isVerticalAlignment(params)) {
                //eslint-disable-line wix-editor/prefer-ternary
                chupchikAlignment = chupchik.y === content.y ? 'top' : 'bottom';
            } else {
                chupchikAlignment = chupchik.x === content.x ? 'left' : 'right';
            }

            _this.setState({
                contentStyle: _(content).thru(rectToStyle).omit(['width', 'height']).assign({ maxWidth: _this.props.maxWidth }).value(),
                chupchikStyle: rectToStyle(chupchik),
                chupchikAlignment: chupchikAlignment
            });
        };

        _this.getTooltipContent = function (overrides) {
            return React.createElement(Bubble, _.assign({}, _this.props, _this.state, overrides, {
                onLayoutChange: _this.onLayoutChange,
                maxWidth: _this.props.maxWidth
            }), _this.props.content);
        };

        _this.openPortal = function () {
            window.clearTimeout(_this.timer);
            var content = _this.getTooltipContent();
            var mount = _this.getMountPoint();
            var animationDuration = _this.props.animationDuration;

            var transitionProps = { children: content, animationDuration: animationDuration };
            _this.tooltipPortal = ReactDOM.unstable_renderSubtreeIntoContainer(_this, withTransition(transitionProps), mount);
        };

        _this.onScroll = function (e) {
            if (_.isFunction(_this.props.onScroll)) {
                _this.props.onScroll(e);
            }
            _this.close();
        };
        return _this;
    }

    _createClass(Tooltip, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            if (this.isOpen()) {
                this.openPortal();
            }
            window.addEventListener('scroll', this.onScroll);

            if (this.props.customTrigger) {
                var customTrigger = ReactDOM.findDOMNode(this.props.customTrigger);
                if (customTrigger && this.props.openOnMouseEnter) {
                    customTrigger.addEventListener('mouseenter', this.open);
                }
                if (customTrigger && this.props.closeOnMouseLeave) {
                    customTrigger.addEventListener('mouseleave', this.close);
                }
            }
        }
    }, {
        key: 'componentWillUpdate',
        value: function componentWillUpdate(nextProps, nextState) {
            var _this2 = this;

            if (this.isOpen() && !shouldBeOpen(nextProps, nextState)) {
                var mountPoint = this.getMountPoint();
                var animationDuration = this.props.animationDuration;

                var props = { children: null, animationDuration: animationDuration };
                this.tooltipPortal = ReactDOM.unstable_renderSubtreeIntoContainer(this, withTransition(props), mountPoint);
                this.timer = window.setTimeout(function () {
                    return _this2.removeMountPoint();
                }, this.props.animationDuration || ANIMATION_DURATION);
            }
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate() {
            if (this.isOpen()) {
                this.openPortal();
            }
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            window.removeEventListener('scroll', this.onScroll);
            window.clearTimeout(this.timer);
            this.removeMountPoint();

            if (this.props.customTrigger) {
                var customTrigger = ReactDOM.findDOMNode(this.props.customTrigger);
                if (customTrigger && this.props.openOnMouseEnter) {
                    customTrigger.removeEventListener('mouseenter', this.open);
                }
                if (customTrigger && this.props.closeOnMouseLeave) {
                    customTrigger.removeEventListener('mouseleave', this.close);
                }
            }
        }
    }, {
        key: 'render',
        value: function render() {
            return template.call(this);
        }
    }], [{
        key: 'ANIMATION_DURATION',
        get: function get() {
            return ANIMATION_DURATION;
        }
    }]);

    return Tooltip;
}(React.Component);

Tooltip.displayName = displayNames.TOOLTIP;

var nodeType = React.PropTypes.oneOfType([React.PropTypes.string.isRequired, React.PropTypes.node.isRequired, React.PropTypes.element.isRequired]);

Tooltip.propTypes = {
    alignment: React.PropTypes.string,
    direction: React.PropTypes.string,
    content: nodeType,
    isOpen: React.PropTypes.bool,
    disabled: React.PropTypes.bool,
    maxWidth: React.PropTypes.number,
    animationDuration: React.PropTypes.number,
    openOnMouseEnter: React.PropTypes.bool,
    closeOnMouseLeave: React.PropTypes.bool,
    customTrigger: React.PropTypes.object, // React ref
    onScroll: React.PropTypes.func
};

Tooltip.defaultProps = {
    disabled: false,
    maxWidth: 240,
    openOnMouseEnter: true,
    closeOnMouseLeave: true
};

module.exports = compose(Tooltip);


// WEBPACK FOOTER //
// ./~/wix-base-ui/lib/controls/tooltip.js